var _style, _rect, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 134,
    viewBox: "0 0 48 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    /* base (off) color for all lights */\n    .light { fill: #7E7B7B }\n\n    /* when svg has one of these classes, show that light in color */\n    svg.red .top { fill: #F26A67 }\n    svg.red .middle, svg.red .bottom { fill: #7E7B7B }\n\n    svg.yellow .middle { fill: #FBA833 }\n    svg.yellow .top, svg.yellow .bottom { fill: #7E7B7B }\n\n    svg.green .bottom { fill: #6CC198 }\n    svg.green .top, svg.green .middle { fill: #7E7B7B }\n  ")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 134,
    rx: 24,
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "bottom light",
    cx: 24,
    cy: 110,
    r: 19
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "middle light",
    cx: 24,
    cy: 67,
    r: 19
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "top light",
    cx: 24,
    cy: 24,
    r: 19
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus);
export default __webpack_public_path__ + "static/media/status.60b96d3d41c45230d09730b4220ce920.svg";
export { ForwardRef as ReactComponent };